import React from 'react'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import Video from '../components/Video/Video'

const Home = () => {
  return (
    <>
    <Navbar/>
    <Video/>
    <Footer/>
    </>
  )
}

export default Home